import styled from "styled-components";

export const CitySubSingleStyled = styled.div`
  padding: 5px 0;
  cursor: pointer;
  font-size: 1.1em;
  /* background-color: gray; */
  font-weight: bold;
`;
